import React from "react";
import { Hero } from "../components/Hero";
import { CollectionIntro } from "../components/CollectionIntro";
import { BeforeAfter } from "../components/BeforeAfter";
import { Challenges } from "../components/Challenges";
import { Volumes } from "../components/Volumes";
import { Tools } from "../components/Tools";
import { Bonuses } from "../components/Bonuses";
import { ValueStack } from "../components/ValueStack";
import { SpecialOffer } from "../components/SpecialOffer";
import { Guarantee } from "../components/Guarantee";
import { Testimonials } from "../components/Testimonials";
import { Author } from "../components/Author";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { FloatingCTA } from "../components/FloatingCTA";
import { PurchasePopup } from "../components/PurchasePopup";
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-307" data-mp="m83hqf1j1no9">
      <Hero data-id="element-308" data-mp="2aabxzw6h3fl" />
      <main data-id="element-309" data-mp="2atjqns46bfw">
        <CollectionIntro data-id="element-310" data-mp="2blejwdw0554" />
        <BeforeAfter data-id="element-311" data-mp="27nv19nedbkp" />
        <Challenges data-id="element-312" data-mp="3tgl6dd6on5xy" />
        <Volumes data-id="element-313" data-mp="3tfa45hsvy68y" />
        <Tools data-id="element-314" data-mp="3teryxvo8whow" />
        <Bonuses data-id="element-315" data-mp="3tf0fpynho75d" />
        <ValueStack data-id="element-316" data-mp="3tio4kkhzo5dr" />
        <SpecialOffer data-id="element-317" data-mp="3pe826t7l3g3a" />
        <Guarantee data-id="element-318" data-mp="3pfriukx5jt5l" />
        <Testimonials data-id="element-319" data-mp="3pf9nrrm87kz9" />
        <Author data-id="element-320" data-mp="3pgktvy3594tj" />
        <FAQ data-id="element-321" data-mp="3kfwryhddn3kj" />
        <FinalCTA data-id="element-322" data-mp="3kg6nekh6y2xm" />
      </main>
      <Footer data-id="element-323" data-mp="3kh7wijencfcp" />
      <FloatingCTA data-id="element-324" data-mp="3khhqsj6q58o7" />
      <PurchasePopup data-id="element-325" data-mp="l0ibk80o5br1" />
    </div>;
}